import {useRouter} from "@tanstack/react-router";
import {useEffect} from "react";

function ScrollToTop() {
	const router = useRouter();

	useEffect(() => {
		const unsubscribe = router.subscribe("onResolved", () => {
			setTimeout(() => {
				window.scrollTo({top: 0, left: 0, behavior: "instant"});
			}, 100);
		});

		return () => unsubscribe();
	}, [router]);

	return <></>;
}

export default ScrollToTop;
